const styles = {
  title: { textAlign: 'center', fontWeight: 600 },
  subtitle: { textAlign: 'center', fontSize: 13, color: '#555', mt: 0.5 },

  content: { pt: 2, px: 2 },
  actions: { justifyContent: 'center', pb: 2, pt: 1 },

  btnPrimary: {
    backgroundColor: '#5236AB',
    color: '#fff',
    '&:hover': { backgroundColor: '#f0f0f0', color: '#5236AB' },
  },
  btnSecondary: {
    backgroundColor: '#5236AB',
    color: '#fff',
    '&:hover': { backgroundColor: '#f0f0f0', color: '#5236AB' },
  },

  cardTabsHeader: {
    px: 1,
    pb: 0.5,
    borderBottom: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    flexWrap: 'wrap',
  },
  cardTabsBar: {
    '& .MuiTab-root': {
      textTransform: 'none',
      minHeight: 44,
      color: '#777',
      fontWeight: 600,
      fontSize: 14,
      fontFamily: 'inherit',
    },
    '& .Mui-selected': { color: '#5236AB' },
    '& .MuiTabs-indicator': {
      backgroundColor: '#5236AB',
      height: 3,
      borderRadius: 3,
    },
  },
  headerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
  },

  tabPanel: { paddingTop: 8 },

  readonlyField: { '& .MuiInputBase-input': { color: '#757575' } },
  outlinedField: (hasValue = true) => ({
    '& .MuiOutlinedInput-input': { color: hasValue ? 'black' : '#A0A0A0' },
    '& .MuiOutlinedInput-input::placeholder': { color: '#888888' },
    '& .MuiOutlinedInput-root': { borderRadius: 0, backgroundColor: '#fff' },
  }),
};

export default styles;